import Button from "Components/Common/Button/Button";
import React from "react";

interface ActionAlertProps {
  icon?: React.ReactNode;
  title?: string;
  text?: string;
  buttonLabel?: string;
  onClick?: () => void;
  variant?: "warning" | "info";
}

const ActionAlert = ({
  icon,
  title,
  text,
  buttonLabel,
  onClick,
  variant = "warning",
}: ActionAlertProps) => {
  return (
    <div className={`actionAlert ${variant === "info" ? "info" : ""}`.trim()}>
      <span className="aaIcon">{icon}</span>
      <div className="aaBody">
        <div className="aaTitle">{title}</div>
        <div className="aaText">{text}</div>
      </div>
      {buttonLabel ? (
        <Button type="button" className="aaBtn" onClick={onClick}>
          {buttonLabel}
        </Button>
      ) : null}
    </div>
  );
};

export default ActionAlert;
